import { fontFamily, capitalizeWords, adjustText } from "./utils.js";
import { addHeader } from "./headerFooter.js";
import autoTable from "jspdf-autotable";

// Función auxiliar para dibujar el borde rojo
const drawSectionBorder = (doc, startY, endY) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginLeft = 13;
  const marginRight = 13;
  const borderWidth = pageWidth - marginLeft - marginRight;

  doc.setDrawColor(204, 0, 0); // Rojo
  doc.setLineWidth(0.5);
  doc.rect(marginLeft, startY, borderWidth, endY - startY);
};

// ==================== INFORMACIÓN GENERAL ====================
export const renderInformacionGeneral = (doc, seccion, report, y) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginLeft = 15;
  const gap = 10;
  const leftMaxWidth = pageWidth / 2 - marginLeft - gap / 2;
  const rightX = pageWidth / 2 + gap / 2;
  const lineHeight = 6;

  // Configurar estilos del título
  const nombreSeccion = seccion.nombreseccion;
  const titulo = nombreSeccion.toUpperCase();
  doc.setFontSize(8);
  doc.setFont(fontFamily, "bold");

  const textWidth = doc.getTextWidth(titulo);
  const paddingX = 2;
  const paddingY = 1;
  const textHeight = 6;

  // Dibujar rectángulo rojo de fondo
  doc.setFillColor(204, 0, 0);
  doc.rect(
    marginLeft - paddingX,
    y - textHeight + paddingY,
    textWidth + paddingX * 2,
    textHeight + paddingY,
    "F",
  );

  doc.setTextColor(255, 255, 255);
  doc.text(titulo, marginLeft, y);
  doc.setTextColor(0, 0, 0);

  y += textHeight + paddingY;

  let startY = y;

  doc.setFont(fontFamily, "normal");
  doc.setFontSize(10);

  // --- Renderizado tipo grid personalizado ---
  // A1: Empresa Cliente
  doc.setFont(fontFamily, "bold");
  doc.text("Empresa Cliente:", marginLeft, y, { align: "left" });
  const empresaLabelWidth = doc.getTextWidth("Empresa Cliente:");
  doc.setFont(fontFamily, "normal");
  doc.text(
    capitalizeWords(report.empresaCliente),
    marginLeft + empresaLabelWidth + 2,
    y,
    { align: "left" },
  );

  // B1: Planta
  doc.setFont(fontFamily, "bold");
  doc.text("Planta:", rightX, y, { align: "left" });
  const plantaLabelWidth = doc.getTextWidth("Planta:");
  doc.setFont(fontFamily, "normal");
  doc.text(capitalizeWords(report.planta), rightX + plantaLabelWidth + 2, y, {
    align: "left",
  });

  y += lineHeight;

  // A2-B2: Ubicación (ocupa ambas columnas)
  doc.setFont(fontFamily, "bold");
  doc.text("Ubicación:", marginLeft, y, { align: "left" });
  const ubicacionLabelWidth = doc.getTextWidth("Ubicación:");
  doc.setFont(fontFamily, "normal");
  // El ancho total disponible es hasta el final de la columna derecha
  const ubicacionMaxWidth = pageWidth - marginLeft - 15; // margen derecho igual que izquierdo
  const ubicacionLines = doc.splitTextToSize(
    capitalizeWords(report.ubicacion),
    ubicacionMaxWidth - ubicacionLabelWidth - 2,
  );
  doc.text(ubicacionLines[0], marginLeft + ubicacionLabelWidth + 2, y, {
    align: "left",
  });
  for (let k = 1; k < ubicacionLines.length; k++) {
    doc.text(
      ubicacionLines[k],
      marginLeft + ubicacionLabelWidth + 2,
      y + k * lineHeight,
      { align: "left" },
    );
  }
  y += Math.max(ubicacionLines.length, 1) * lineHeight;

  // A3: Representante
  doc.setFont(fontFamily, "bold");
  doc.text("Representante:", marginLeft, y, { align: "left" });
  const representanteLabelWidth = doc.getTextWidth("Representante:");
  doc.setFont(fontFamily, "normal");
  doc.text(
    capitalizeWords(report.representantePlanta),
    marginLeft + representanteLabelWidth + 2,
    y,
    { align: "left" },
  );

  // B3: Fecha
  doc.setFont(fontFamily, "bold");
  doc.text("Fecha:", rightX, y, { align: "left" });
  const fechaLabelWidth = doc.getTextWidth("Fecha:");
  doc.setFont(fontFamily, "normal");
  doc.text(capitalizeWords(report.fecha), rightX + fechaLabelWidth + 2, y, {
    align: "left",
  });

  y += lineHeight;

  // A4: Inspector
  doc.setFont(fontFamily, "bold");
  doc.text("Inspector:", marginLeft, y, { align: "left" });
  const inspectorLabelWidth = doc.getTextWidth("Inspector:");
  doc.setFont(fontFamily, "normal");
  doc.text(
    capitalizeWords(report.inspector),
    marginLeft + inspectorLabelWidth + 2,
    y,
    { align: "left" },
  );

  let extraItems = seccion.items || [];
  let yA = y; // A4 ya está en la línea actual
  let yB = y; // B4 ya está en la línea actual

  for (let i = 0; i < extraItems.length; i++) {
    const item = extraItems[i];
    let label = item.label || item.descripcion || "";
    let value =
      item.value !== undefined
        ? String(item.value)
        : item.respuesta !== undefined
          ? String(item.respuesta)
          : "";
    if (!label && value) {
      label = value;
      value = "";
    }
    if (i % 2 === 0) {
      // B columna (B4, B6, ...)
      if (i > 0) yB += lineHeight;
      doc.setFont(fontFamily, "bold");
      const labelWidth = doc.getTextWidth(label);
      const valueLines = doc.splitTextToSize(
        value,
        leftMaxWidth - labelWidth - 4,
      );
      doc.text(label, rightX, yB, { align: "left" });
      doc.setFont(fontFamily, "normal");
      if (valueLines.length > 0 && value) {
        doc.text(valueLines[0], rightX + labelWidth + 2, yB, { align: "left" });
        for (let k = 1; k < valueLines.length; k++) {
          doc.text(
            valueLines[k],
            rightX + labelWidth + 2,
            yB + k * lineHeight,
            { align: "left" },
          );
        }
      }
      yB += (valueLines.length - 1) * lineHeight;
    } else {
      // A columna (A5, A7, ...)
      yA += lineHeight;
      doc.setFont(fontFamily, "bold");
      const labelWidth = doc.getTextWidth(label);
      const valueLines = doc.splitTextToSize(
        value,
        leftMaxWidth - labelWidth - 4,
      );
      doc.text(label, marginLeft, yA, { align: "left" });
      doc.setFont(fontFamily, "normal");
      if (valueLines.length > 0 && value) {
        doc.text(valueLines[0], marginLeft + labelWidth + 2, yA, {
          align: "left",
        });
        for (let k = 1; k < valueLines.length; k++) {
          doc.text(
            valueLines[k],
            marginLeft + labelWidth + 2,
            yA + k * lineHeight,
            { align: "left" },
          );
        }
      }
      yA += (valueLines.length - 1) * lineHeight;
    }
  }
  // El nuevo y debe ser el mayor entre yA y yB
  // Siempre sumar lineHeight para incluir la última línea (Inspector o el último item extra)
  let finalY;
  if (extraItems.length > 0) {
    finalY = Math.max(yA, yB) + lineHeight;
  } else {
    finalY = y + lineHeight;
  }

  drawSectionBorder(doc, startY - 5, finalY - 4);
  return finalY + 5;
};

// ==================== SECCIONES CON TABLAS ====================
export const renderItemsSection = (doc, seccion, y) => {
  const marginLeft = 15;

  // Configurar estilos del título
  const nombreSeccion = seccion.nombreseccion;
  const titulo = nombreSeccion.toUpperCase();
  doc.setFontSize(8);
  doc.setFont(fontFamily, "bold");

  const textWidth = doc.getTextWidth(titulo);
  const paddingX = 2;
  const paddingY = 1;
  const textHeight = 6;

  doc.setFillColor(204, 0, 0);
  doc.rect(
    marginLeft - paddingX,
    y - textHeight + paddingY,
    textWidth + paddingX * 2,
    textHeight + paddingY,
    "F",
  );

  doc.setTextColor(255, 255, 255);
  doc.text(titulo, marginLeft, y);
  doc.setTextColor(0, 0, 0);

  y += textHeight + paddingY;
  const startY = y;

  const rows = seccion.items.map((item) => [
    item.descripcion,
    item.respuesta || "N/A",
  ]);

  autoTable(doc, {
    head: [["Descripción", "Respuesta"]],
    body: rows,
    startY: y,
    margin: { left: marginLeft, right: marginLeft }, // 👈 SOLUCIÓN AQUÍ
    styles: {
      font: "helvetica",
      fontSize: 10,
      cellPadding: 2,
      halign: "center",
    },
    headStyles: {
      fillColor: [204, 0, 0],
      textColor: [255, 255, 255],
      fontSize: 10,
    },
    bodyStyles: {
      fillColor: [245, 245, 245],
    },
    alternateRowStyles: {
      fillColor: [255, 255, 255],
    },
    didDrawPage: () => {
      addHeader(doc, 10, doc.tipoMantenimiento);
    },
  });

  drawSectionBorder(doc, startY - 4, doc.lastAutoTable.finalY - 4);
  return doc.lastAutoTable.finalY + 20;
};

// ==================== SECCIONES DE TEXTO ====================
const renderTextSection = (doc, seccion, y) => {
  const maxWidth = doc.internal.pageSize.getWidth() - 30;
  const marginLeft = 15; // 👈 Unificamos el margen aquí

  const nombreSeccion = seccion.nombreseccion;
  const titulo = nombreSeccion.toUpperCase();
  doc.setFontSize(8);
  doc.setFont(fontFamily, "bold");

  const textWidth = doc.getTextWidth(titulo);
  const paddingX = 2;
  const paddingY = 1;
  const textHeight = 6;

  doc.setFillColor(204, 0, 0);
  doc.rect(
    marginLeft - paddingX,
    y - textHeight + paddingY,
    textWidth + paddingX * 2,
    textHeight + paddingY,
    "F",
  );

  doc.setTextColor(255, 255, 255);
  doc.text(titulo, marginLeft, y);
  doc.setTextColor(0, 0, 0);

  y += textHeight + paddingY;
  let startY = y;

  doc.setFont(fontFamily, "normal");
  doc.setFontSize(10);

  seccion.items.forEach((item) => {
    let fullText = item.descripcion || item.respuesta || "N/A";
    if (item.descripcion && item.respuesta) {
      fullText = `${item.descripcion} ${item.respuesta}`;
    }

    if (item.textbold === true) {
      doc.setFont(fontFamily, "bold");
    } else {
      doc.setFont(fontFamily, "normal");
    }

    const adjustedText = adjustText(doc, fullText, maxWidth);
    for (const line of adjustedText) {
      if (y > doc.internal.pageSize.getHeight() - 30) {
        drawSectionBorder(doc, startY - 4, y - 4);
        doc.addPage();
        addHeader(doc, 10, doc.tipoMantenimiento);
        y = 50;
        startY = y;
        doc.setFont(fontFamily, item.textbold === true ? "bold" : "normal");
        doc.setFontSize(10);
      }
      doc.text(line, marginLeft, y);
      y += 6;
    }
  });

  drawSectionBorder(doc, startY - 4, y - 4);
  return y + 5;
};

export const renderImportanteSection = renderTextSection;
export const renderTrabajoARealizarSection = renderTextSection;
export const renderActividadesRealizadasSection = renderTextSection;
export const renderObservacionesSection = renderTextSection;
export const renderComentariosSection = renderTextSection;
export const renderGenericSection = renderTextSection;
